<app-svg></app-svg>
<nav app-nav #navigationBar class="nav" [class.dark-bg]="isDarkBg" [parent]="this"></nav>
<!-- <div #navOffset [class.hide]="isLandingPage"></div> -->
<router-outlet></router-outlet>
<app-images-preloader></app-images-preloader>
<footer app-footer></footer>